<template>
  <DatatableReportV3
    v-if="tenantLoaded"
    ref="outstanding_draws_datatable"
    :title="`Outstanding ${intervalNamePlural}`"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import { mapState } from "vuex";

import Badge from "@/components/Badge.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      tenantLoaded({ tenant }) {
        return !!tenant;
      },
      intervalName({ tenant }) {
        return (
          tenant?.feature_flags?.progress_billing_interval_name || "Installment"
        );
      },
      intervalNamePlural({ tenant }) {
        return (
          tenant?.feature_flags?.progress_billing_interval_name_plural ||
          `${
            tenant?.feature_flags?.progress_billing_interval_name ||
            "Installment"
          }s`
        );
      }
    }),
    config() {
      return {
        order: [
          [0, "asc"],
          [6, "asc"]
        ],
        language: {
          emptyTable: `There are currently no outstanding ${this.intervalNamePlural.toLowerCase()}.`
        },
        columns: [
          {
            data: "status_rank",
            title: "",
            visible: false,
            searchable: false
          },
          {
            data: "customer",
            aggregateTitle: "Customers"
          },
          { data: "job", title: "Job #" },
          { data: "invoice", title: "Invoice #" },
          { data: "draw_name", title: `${this.intervalName} Name` },
          {
            data: "draw_amount",
            title: `${this.intervalName} Amount`,
            className: "text-right",
            searchable: false
          },
          {
            data: "due_date",
            title: "Due Date",
            searchable: false
          },
          {
            data: "due_status",
            title: "Status",
            filterName: "due_status",
            searchable: false
          },
          {
            data: "department",
            title: "Department",
            filterName: "department_id",
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "badge-vue",
            component: Badge
          }
        ]
      };
    }
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Outstanding Draws" });
  }
};
</script>
